export default {
  user: null,
  isLoggedIn: !!localStorage.getItem('access_token'),
  dialogOpen: !!localStorage.getItem('dialog_open'),
  roomDialogOpen: !!localStorage.getItem('rooms_dialog'),
}
